export const compareValues = (
  original: { checked?: boolean | 'indeterminate'; name: string; value?: number | string },
  proposed: { checked?: boolean | 'indeterminate'; name: string; value?: number | string },
  originalChildren: any[] = [],
  proposedChildren: any[] = []
): boolean => {
  // Compare name
  if (original.name !== proposed.name) return true

  // Compare value (with null/undefined checks)
  if (original.value !== proposed.value) {
    if (original.value === undefined && proposed.value === 0) return false
    if (original.value === 0 && proposed.value === undefined) return false
    return true
  }

  // Compare checked status
  if (original.checked !== proposed.checked) {
    // Handle cases where one is undefined and the other is false
    if (original.checked === undefined && proposed.checked === false) return false
    if (original.checked === false && proposed.checked === undefined) return false
    return true
  }

  // For parent items, compare if children count changed
  if (originalChildren.length !== proposedChildren.length) return true

  return false
}
